<template>
  <div class="wrapper">
    <Menu />
    <div class="body-area">
      <div class="container-fluid">
        <div class="slider-box position-relative row" style="z-index: 99">
          <div
            class="header-area position-absolute w-100 bg-transparent border-0 fc-5"
            style="z-index: 9"
          >
            <div class="container-fluid">
              <div class="row">
                <div class="col-6">
                  <a href="#">
                    <span class="back-arrow mt-4"></span>
                  </a>
                </div>
                <div class="col-6 text-right">
                  <a href="#"></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-left: -15px; margin-right: -15px; position: relative">
          <img src="/static/img/sinanerdem.png" class style="width: 100%;" />
          <h1
            class="fs-32 fc-5 slider-title position-absolute"
            style="z-index: 9999;
    bottom: 20px;
    left: 20px;"
          >Çaylak</h1>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="content-block py-3">
              <p>
                Metrobüsten Şirinevler durağında inip, Ataköy tarafından çıkış
                yaparak, kısa bir yürüyüşle salona ulaşabilirsin.
                <br />
                <br />Yenikapı - Atatürk Havalimanı (M1A) Metro hattında, Ataköy
                durağında inip kısa bir yürüyüşle salona ulaşabilirsin.
                <br />
                <br />Ataköy Marmaray istasyonunda inip, kısa bir yürüyüş ile
                salona ulaşabilirsin.
                <br />
                <br />Kadıköy ve Bostancı’dan Deniz Otobüsü ile Bakırköy’e
                gelerek bu noktadan kısa bir taksi yolculuğu ile salona
                ulaşabilirsin ya da MR20 otobüsünü kullanarak salona
                gelebilirsin.
                <br />
                <br />
                <b>Ya da;</b>
              </p>

              <div class="col-12 p-0 pt-3">
                <button
                  @click="
                    $buy('http://maps.google.com/maps?q=40.9886324,28.8517036')
                  "
                  class="confirm-button"
                >BENİ MAÇA GÖTÜR!</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
export default {
  name: "Caylak",
  components: {
    Footer,
    Menu,
    Header
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/Caylak.vue